import { render, staticRenderFns } from "./VideoModal.vue?vue&type=template&id=192a8f89&scoped=true"
import script from "./VideoModal.js?vue&type=script&lang=js&external"
export * from "./VideoModal.js?vue&type=script&lang=js&external"
import style0 from "./VideoModal.scss?vue&type=style&index=0&id=192a8f89&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192a8f89",
  null
  
)

export default component.exports